import * as React from 'react';
import PropTypes from 'prop-types';
import CssBaseline from '@mui/material/CssBaseline';
import useScrollTrigger from '@mui/material/useScrollTrigger';
import Box from '@mui/material/Box';
import Zoom from '@mui/material/Zoom';
import Login from "./Components/Login";
import {HashRouter, Navigate, Route, Routes, useLocation} from "react-router-dom";
import {APP_DATA} from "./config/settings";
import {createBrowserHistory} from "history";
import DriveLayout from "./Components/DriveLayout";
import NotificationProvider from "./providers/NotificationProvider";
import AppNotification from "./Components/AppNotification";

function ScrollTop(props) {
    const {children, window} = props;
    // Note that you normally won't need to set the window ref as useScrollTrigger
    // will default to window.
    // This is only being set here because the demo is in an iframe.
    const trigger = useScrollTrigger({
        target: window ? window() : undefined,
        disableHysteresis: true,
        threshold: 100,
    });

    const handleClick = (event) => {
        const anchor = (event.target.ownerDocument || document).querySelector(
            '#back-to-top-anchor',
        );

        if (anchor) {
            anchor.scrollIntoView({
                behavior: 'smooth',
                block: 'center',
            });
        }
    };

    return (
        <Zoom in={trigger}>
            <Box
                onClick={handleClick}
                role="presentation"
                sx={{position: 'fixed', bottom: 16, right: 16}}
            >
                {children}
            </Box>
        </Zoom>
    );
}

ScrollTop.propTypes = {
    children: PropTypes.element.isRequired,
    /**
     * Injected by the documentation to work in an iframe.
     * You won't need it on your project.
     */
    window: PropTypes.func,
};
export default function App() {

    const jwt = localStorage.getItem('jwt');
    const hist = createBrowserHistory();
    return (
        <React.Fragment>
            <HashRouter history={hist}>
                <NotificationProvider>
                    <Routes>
                        <Route exact path="/login" element={<Login/>}/>
                        <Route exact path="/drive" element={<DriveLayout/>}/>
                        <Route path="/" element={jwt ? <Navigate to={APP_DATA.WELCOME_ROUTER}/> : <Navigate to="/login"/>}/>

                    </Routes>
                    <AppNotification/>
                </NotificationProvider>
                <CssBaseline/>

            </HashRouter>

        </React.Fragment>
    );
}
